// extracted by mini-css-extract-plugin
export default {"swiper":"Benefactors_swiper__A9AeB","swiperSlide":"Benefactors_swiperSlide__zr4jT"};